import 'reflect-metadata';
import axiosClient from './axios-client';
import { injectable } from 'inversify';
import {
  PaginatedResult,
  Response,
} from '@/_shared/_api/models/response.model';
import { ERRORS } from '../constants';
import { Brand } from '../_api/models/brands.model';
import { getSession } from 'next-auth/react';
import jwt from 'jsonwebtoken';
import { Category } from '../_api/models/categories.model';
import { BrandRequestRequest } from '../models/brand/request-brand-request.model';

@injectable()
export class BrandService {
  async getAllBrands(
    offset: number,
    limit: number,
    searchText?: string,
    categoriesFilter?: Category[]
  ): Promise<Response<PaginatedResult>> {
    try {
      const response = await axiosClient.get('/api/brand', {
        params: {
          offset: offset,
          limit: limit,
          searchText: searchText,
          categoriesFilter: categoriesFilter?.map(
            (category) => category.primaryId
          ),
        },
      });

      return response;
    } catch {
      throw new Error(ERRORS.unexpectedError);
    }
  }

  async getCategories(): Promise<Category[]> {
    try {
      const session = await getSession();

      const response = await axiosClient.get<Response<Category[]>>(
        `/api/brand/get-categories`,
        {
          headers: {
            CubeAsiaAuthorization: `${jwt.decode(
              session?.user.cubeAsiaBearer!
            )}`,
          },
        }
      );

      return response.data.data as Category[];
    } catch {
      throw new Error(ERRORS.unexpectedError);
    }
  }

  async getBrandById(id: number): Promise<Response<Brand | null>> {
    try {
      const session = await getSession();
      const response = await axiosClient.get<Response<Brand>>(
        `/api/brand/${id}`,
        {
          headers: {
            CubeAsiaAuthorization: `${jwt.decode(session?.user.cubeAsiaBearer!)}`,
          },
        }
      );

      return response.data;
    } catch {
      throw new Error(ERRORS.unexpectedError);
    }
  }

  async createBrandRequest(
    request: BrandRequestRequest
  ): Promise<Response<boolean | null>> {
    const session = await getSession();
    const response = await axiosClient.post<Response<boolean>>(
      `/api/brand/brand-request`,
      request,
      {
        headers: {
          CubeAsiaAuthorization: `${jwt.decode(session?.user.cubeAsiaBearer!)}`,
        },
      }
    );

    return response.data;
  }
}
